import { Component, OnInit, ViewChild } from "@angular/core";
import { FeatureViews } from "src/app/ui/models/domains/features/custom-feature-views";
import { PageViews } from "src/app/ui/models/domains/features/custom-page-views";
import { MaskInput } from "src/app/ui/models/domains/masks/mask.model";
import { FileBeneficiary } from "src/app/ui/models/domains/pbm/Beneficiary/file-beneficiary";
import { CompanyMasterData } from "src/app/ui/models/domains/pbm/companies/company-master-data";
import { FiscalNumber } from "src/app/ui/models/domains/pbm/fiscal-number";
import { FileIndustryProductsDiscounts } from "src/app/ui/models/domains/pbm/industry/file-industry-products-discounts.model";
import { FeatureViewService } from "src/app/ui/services/feature-view.service";
import { LoadingService } from "src/app/ui/services/loading.service";
import { CompanyService } from "src/app/ui/services/pbm/company.service";
import { IndustryDiscountsService } from "src/app/ui/services/pbm/industry-discounts.service";
import { UserService } from "src/app/ui/services/user.service";
import { environment } from "src/environments/environment";
import { Toast } from "../../../toast/toast";

@Component({
  selector: "add-industry-discounts",
  templateUrl: "./add-industry-discounts.component.html",
  styleUrls: ["./add-industry-discounts.component.scss"],
})
export class AddIndustryDiscountsComponent implements OnInit {
  filesInput: FileList;
  fileName: string;
  company: CompanyMasterData;
  fiscalNumber: string;
  fileIndustryProductDiscounts = new FileIndustryProductsDiscounts();
  searchNotFound = false;
  searchActionFired = false;
  fiscalNumberMask = MaskInput.getFicalNumberMask();
  fileLink = environment.industryDiscountsTemplateRegisterFileUploadLink;

  constructor(
    private loadingService: LoadingService,
    private companyService: CompanyService,
    private toast: Toast,
    private industryService: IndustryDiscountsService,
    private featureViewService: FeatureViewService,
  ) {}

  ngOnInit() {
    this.featureViewService.activeFeatureView(FeatureViews.AddIndustryDiscounts, PageViews.LpmManagementPageView);
  }

  onPressEnterSearchCompany(event: any): void {
    if (event.key === "Enter") {
      this.findIndustry(this.fiscalNumber);
    }
  }

  async findIndustry(formFiscalNumber: string) {
    if (FiscalNumber.isValid(formFiscalNumber)) {
      const fiscalNumber = new FiscalNumber(formFiscalNumber);
      const ref = this.loadingService.beginLoading();

      try {
        const industry = await this.industryService.findExistentIndustry(fiscalNumber);

        if (industry) {
          this.company = await this.companyService.searchCompanyByFicalNumberFromMDM(fiscalNumber);
          this.fileIndustryProductDiscounts.setFiscalNumber(fiscalNumber);
          this.searchNotFound = false;
        }
      } catch {
        this.searchCompany(fiscalNumber);
      } finally {
        this.loadingService.finishLoading(ref);
      }
    } else {
      this.toast.showWarningToast("Digite um CNPJ válido!");
    }
  }

  private async searchCompany(fiscalNumber: FiscalNumber) {
    if (fiscalNumber) {
      const ref = this.loadingService.beginLoading();

      try {
        const industry = await this.industryService.getIndustryDiscount(fiscalNumber);
        if (industry) {
          this.company = await this.companyService.searchCompanyByFicalNumberFromMDM(fiscalNumber);
          this.fileIndustryProductDiscounts.setFiscalNumber(fiscalNumber);
          this.searchNotFound = false;
        } else {
          this.company = null;
          this.searchNotFound = true;
          this.toast.showWarningToast("Indústria não localizada!");
        }
      } catch {
        this.company = null;
        this.searchNotFound = true;
        this.toast.showWarningToast("Indústria não localizada!");
      } finally {
        this.loadingService.finishLoading(ref);
        this.fiscalNumber = "";
      }
    } else {
      this.company = null;
      this.searchNotFound = true;
      this.fiscalNumber = "";
    }
  }

  getFile(event: any) {
    const files = event.target.files;
    if (!FileBeneficiary.isCsvExtension(files.item(0))) {
      this.toast.showWarningToast("Insira um arquivo .csv");
    } else {
      const file = files.item(0);
      this.filesInput = files;
      this.fileName = file.name;
      this.fileIndustryProductDiscounts.setFile(file);
    }
    event.target.value = null;
  }

  async uploadFile() {
    if (this.fileIndustryProductDiscounts.hasFile()) {
      const ref = this.loadingService.beginLoading();
      try {
        const importIndustryProductDiscountResult = await this.industryService.addIndustryProductDiscounts(this.fileIndustryProductDiscounts);
        this.toast.showSuccessToast(importIndustryProductDiscountResult.getMessageResult());
      } catch (message) {
        var text = message.getMessageResult()
        if(text.includes("Exception:")){
          text = this.exceptionText(text);
        }
        this.toast.showWarningToast(text);
      } finally {
        this.filesInput = null;
        this.fileName = null;
        this.fileIndustryProductDiscounts.setFile(null);
        this.loadingService.finishLoading(ref);
      }
    } else {
      this.toast.showWarningToast("Insira um arquivo .csv");
    }
  }

  hasCompany(): boolean {
    return !!this.company;
  }

  exceptionText(text){
    try{      
      var args = text.split(/\r\n|\r|\n/)
      args = ((args[0] || "").split("Exception:")[1] || "") || "Ocorreu um erro durante a solicitação. Tente novamente mais tarde.";
      return args;
    }
    catch{
      return text;
    }
  }
}
